import { IconWarningSign16 } from '@cian/ui-kit';

import { FC } from 'react';

import { NarrowCardMoreControlsItem } from 'shared/components/MoreItemComplaint';
import { useCardComplaintContext } from 'shared/context/CardComplaintContext';

export const MoreItemComplaintContainer: FC = () => {
  const { onModalOpen } = useCardComplaintContext();

  return <NarrowCardMoreControlsItem icon={<IconWarningSign16 />} title="Пожаловаться" onClick={onModalOpen} />;
};
